import { render, staticRenderFns } from "./PostPublishConfirm.vue?vue&type=template&id=2ebd350e&"
import script from "./PostPublishConfirm.vue?vue&type=script&lang=ts&"
export * from "./PostPublishConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports